// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PlusBadge":"bcy_a bhl_rj bhl_rk bhl_vh bhl_eb bhl_vf bhl_gs bhl_kh"};